import type { Messages } from './en';

export const de: Messages = {
  nav: {
    soon: 'Bald verfügbar',
  },
  hero: {
    eyebrow: 'Für Racer, die reisen',
    headlineLine1: 'Du konzentrierst dich auf das Rennen.',
    headlineLine2: 'Um den Plan kümmern wir uns.',
    lead: 'Das Rennen dauert drei Stunden. Das Wochenende drumherum — die richtigen Hotels, die Transfers, das Essen, der Rückflug — sind drei Wochen voller offener Tabs. Den schweren Teil hast du schon erledigt; den Rest übernehmen wir.',
    ctaNote: 'Kostenlos · ohne Karte',
  },
  mock: {
    from: 'Ab',
    sortCost: 'Gesamtkosten',
    sortDate: 'Datum',
    bestValue: 'Bestes Verhältnis',
    allIn: 'alles inkl.',
  },
  problem: {
    eyebrow: 'Das Wochenende, nicht das Rennen',
    heading: 'Das Rennen ist nie da, wo der Name es verspricht.',
    body1:
      'Zuerst rechnest du aus, ob du es dir überhaupt leisten kannst — die Anmeldung ist der einfache Teil; es sind die Flüge, die Hotels und alles andere, was entscheidet, ob die Reise überhaupt stattfindet. Nehmen wir an, sie tut es.',
    body2:
      'Und dann liegt der Austragungsort eine Stunde außerhalb der Stadt. Also ein Hotel am Start, ein zweites zurück in der Stadt zur Erholung, Züge, die du nie gefahren bist, Abendessen, das du zweimal suchen musst, und ein Rückflug, den du rückwärts planen musst. Nichts davon ist das Rennen — und alles landet bei dir.',
    realCost: 'Echte Kosten?',
    returnLeg: 'Rückflug',
    crewMessage: '„wo schlafen wir??“',
    yourWeekend: 'Dein Wochenende',
    sorted: 'Erledigt',
    flights: 'Flüge',
    stay: 'Unterkunft · 2 Nächte',
    race: 'Rennen · Beast',
    allIn: 'Gesamt',
  },
  discovery: {
    eyebrow: 'Was es macht',
    heading: 'Wir kalkulieren die ganze Reise, bevor du dich festlegst.',
    lead: 'Sag uns, wo du startest. RaceAtlas sortiert jedes Rennen danach, was es dich wirklich kostet — von Tür zu Tür — Anmeldung, Flug oder Fahrt und eine Unterkunft. Ehrliche Spannen, eine Verlässlichkeitsbewertung auf jeder Zahl und das günstigste lohnende Rennen ganz oben.',
    feat1Kicker: 'Ehrliche Zahlen',
    feat1Heading: 'Eine Verlässlichkeitsbewertung für jede Kostenposition',
    feat1Body:
      'Anmeldung, Anreise, Unterkunft — jede Zeile zeigt, wie viele echte Daten dahinterstecken. Niemals falsche Genauigkeit.',
    feat2Kicker: 'Von deiner Haustür',
    feat2Heading: 'Fahren oder fliegen, für dich entschieden',
    feat2Body:
      'Wir berechnen, ob du von zu Hause fahren oder fliegen würdest — und sortieren die Gesamtkosten entsprechend.',
    feat3Kicker: 'Das Lohnende zuerst',
    feat3Heading: 'Sortiert, nicht nur aufgelistet',
    feat3Body:
      'Das günstigste Rennen, das du wirklich willst, steht oben. Sortiere mit einem Tipp nach Datum oder Distanz neu.',
  },
  twoJobs: {
    eyebrow: 'Kostenlos vs. bezahlt',
    heading: 'Kostenlos sagt dir, was es kostet. 9,99 € sagt dir, was zu tun ist.',
    freeTag: 'Kostenlos · ein Werkzeug',
    freeHeading: 'Wissen, was es kostet',
    freeBody:
      'Suche, sortiere und vergleiche jedes Rennen nach echten Gesamtkosten von zu Hause aus. Speichere deine Auswahl. Unbegrenzt, für immer.',
    paidTag: '9,99 € · ein Service',
    paidHeading: 'Wissen, was zu tun ist',
    paidBody:
      'Ein Wochenendplan, der für dich entscheidet — Zeiten am Renn-Morgen, Parken und Beutelabgabe, und Kaffee und Abendessen schon ausgewählt, auf deiner Route und nach deiner Ernährung.',
  },
  payoff: {
    eyebrow: 'Das 9,99-€-Programm',
    heading: 'Wie ein Freund, der das Rennen schon gemacht hat.',
    body1:
      'Ein Freund gibt dir keine Liste mit acht Cafés — er sagt dir, wohin du gehen sollst. Wir auch: der Kaffee auf dem Weg zum Start, das Essen nach dem Rennen, das zu deiner Ernährung passt, die exakte Minute zum Losfahren, damit du die Beutelabgabe nicht verpasst. Schon ausgewählt, mit Begründung. Ändere alles mit einem Tipp.',
    body2:
      'Es kennt die Strecke, die Startwellen, das Parken, die Fahrt. Das, was du sonst nur auf die harte Tour lernst — beim zweiten Mal.',
    cardDay: 'Sa 23. Aug · Renntag',
    leaveHotel: 'Hotel verlassen',
    leaveHotelSub: '15 Min · Parkplatz öffnet 07:00',
    coffee: 'Kaffee · Bar Nuovo',
    coffeeSub: 'auf deiner Route · +6 Min · öffnet 06:30',
    raceStart: 'Start · Beast',
    postRace: 'Essen nach dem Rennen · Sa Tanca',
    postRaceSub: 'vegetarisch · +3 Min auf dem Rückweg',
  },
  who: {
    eyebrow: 'Für wen es ist',
    heading: 'Gemacht für Racer, die zum Wettkampf reisen.',
    lead: 'Wettkampforientierte Ausdauersportler mit 5 bis 15 Events im Jahr — Spartan plus Hyrox plus eine UTMB-Etappe plus ein Tough Mudder ist ein ganz normaler Kalender. Wenn du einmal im Jahr antrittst, reicht die kostenlose Stufe völlig. Wenn du mehrere Wochenenden im Ausland planst und willst, dass es sich weniger nach Arbeit anfühlt — dann sind wir das.',
  },
  pricing: {
    eyebrow: 'Preise',
    heading: 'Kostenlos zum Entscheiden. Zahle für den Teil, den du sonst nirgends bekommst.',
    freeTier: 'Kostenlos',
    freeAmount: '0 €',
    freeCadence: 'für immer',
    freeDesc:
      'Sortiere jedes Rennen nach echten Kosten, von deiner Haustür. Speichere eine Auswahl.',
    freeItem1: 'Unbegrenzte Suche & Kostensortierung',
    freeItem2: 'Bis zu 3 gespeicherte Pläne',
    freeItem3: 'Kalender + Erinnerungen',
    perTripTier: 'Pro Reise',
    perTripBadge: 'Das Produkt',
    perTripAmount: '9,99 €',
    perTripCadence: 'einmalig pro Rennen',
    perTripDesc:
      'Das Rennwochenende, geplant und entschieden — wie ein Freund, der es schon gemacht hat.',
    perTripItem1: 'Zeitplan für den Renn-Morgen + Parken',
    perTripItem2: 'Kaffee, Essen & Erholung, vorausgewählt',
    perTripItem3: 'Teilbar · 7 Tage rückerstattbar',
    seasonTier: 'Saisonpass',
    seasonBadge: 'Bald',
    seasonAmount: '45 €',
    seasonCadence: 'pro Jahr',
    seasonDesc: 'Für 8+ Rennen im Jahr. Deine ganze Saison, unbegrenzt, an einem Ort.',
    seasonItem1: 'Alle Programme inklusive',
    seasonItem2: 'Saisonausgaben, Budget & Überschneidungen',
    seasonItem3: 'Buchungszeitpunkt (nach dem Launch)',
  },
  final: {
    heading: 'Du konzentrierst dich auf das Rennen.',
    lead: 'Um den Rest kümmern wir uns — was es kostet, wo du schläfst, wie du hinkommst, was du nach der Ankunft tust. Kostenlos zum Start, ohne Karte.',
  },
  footer: {
    privacy: 'Datenschutz',
    terms: 'AGB',
    contact: 'Kontakt',
  },
  seo: {
    title: 'Race Atlas — Du konzentrierst dich auf das Rennen, um den Plan kümmern wir uns',
    description:
      'Race Atlas plant deine Rennwochenenden von Anfang bis Ende — was sie wirklich kosten, wo du schläfst, wie du hinkommst und was du nach der Ankunft tust. Du konzentrierst dich auf das Rennen; um den Plan kümmern wir uns.',
  },
};
